import SilHomeProfileContainer from "./SilHomeProfile.container";

export default SilHomeProfileContainer;
